// extracted by mini-css-extract-plugin
export default {"container":"Brick_container__LxYQM","productListContainer":"Brick_productListContainer__DLNOI","productGrid":"Brick_productGrid__PR+fp"};